<div class="filter-component">
  <button
    class="expansion-filter"
    mat-menu-item
    #ramosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="ramos"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="code-branch" class="expansion-icon-text" />
      <span class="filter-text"
        >Ramos
        <ng-container *ngIf="getRamosCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #ramos="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-ramos
      [(filtroRamo)]="filtroRamo"
      [currentTab]="currentTab"
    ></sub-filtro-ramos>
  </mat-menu>

  <button
    class="expansion-filter"
    mat-menu-item
    #usuariosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="usuarios"
    *ngIf="
      (listaUsuarios?.ativos && listaUsuarios?.ativos.length) ||
      (listaUsuarios?.inativos && listaUsuarios?.inativos.length)
    "
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroUserGroupSolid" class="expansion-icon-text" />
      <span class="filter-text"
        >Usuários
        <ng-container *ngIf="getUsersCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #usuarios="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-usuarios
      [(filtroUsuario)]="filtroUsuario"
    ></sub-filtro-usuarios>
  </mat-menu>
</div>
